import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEdit } from 'react-icons/fa';
import {toPersianNumbers} from "../../utils/toPersianNumbers";

export default function CustomerUserTable({ profiles, loading }) {
  const navigate = useNavigate();
  const handleViewProfile = (profile) => {
  if (profile.id) {
    // رفتن به صفحه مشاهده پروفایل مشتری در فرانت
    navigate(`/admin-panel/customer-user-management/${profile.id}/view`);
  } else {
    alert('این کاربر پروفایل مشتری ندارد');
  }
};

  const handleEditProfile = (profile) => {
  if (profile.id) {
    // رفتن به صفحه ویرایش پروفایل مشتری در فرانت
    navigate(`/admin-panel/customer-user-management/${profile.id}/edit`,);
  } else {
    alert('این کاربر پروفایل مشتری ندارد');
  }
};

  if (loading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <span className="mr-2">در حال بارگذاری...</span>
      </div>
    );
  }

  if (!profiles || profiles.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        هیچ کاربری یافت نشد
      </div>
    );
  }

  return (
    <div className="overflow-x-auto bg-white rounded-lg shadow">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
             ردیف
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
             کد مشتری
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              نام و نام خانوادگی
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              شماره موبایل
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              استان/شهر
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              وضعیت
            </th>
            <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              عملیات
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {profiles.map((profile, index) => (
            <tr key={profile.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                {toPersianNumbers(index+1)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                {toPersianNumbers(profile.customer_code)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                {profile.full_name || '---'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 text-center">
                {toPersianNumbers(profile.phone_number)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600 text-center">
                {profile.province}-{profile.city}
              </td>
              {profile.is_active?(<td className="px-6 py-4 whitespace-nowrap text-sm text-green-600 text-center">
                فعال
              </td>):(<td className="px-6 py-4 whitespace-nowrap text-sm text-red-600 text-center">
                غیرفعال
              </td>)}
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                <div className="flex gap-2">

                  <button
                    onClick={() => handleViewProfile(profile)}
                    disabled={!profile.id}
                    className={`p-2 rounded transition duration-200 ${
                      profile.id 
                        ? 'text-blue-600 hover:text-blue-900 hover:bg-blue-50' 
                        : 'text-gray-400 cursor-not-allowed'
                    }`}
                    title="مشاهده پروفایل"
                  >
                    <FaEye size={16} />
                  </button>


                  <button
                    onClick={() => handleEditProfile(profile)}
                    disabled={!profile.id}
                    className={`p-2 rounded transition duration-200 ${
                      profile.id 
                        ? 'text-green-600 hover:text-green-900 hover:bg-green-50' 
                        : 'text-gray-400 cursor-not-allowed'
                    }`}
                    title="ویرایش پروفایل"
                  >
                    <FaEdit size={16} />
                  </button>

                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}